import type { FunctionComponent } from "react";

import Hint from "~/components/Hint";

type Props = { errors?: string[] };

const EInvoiceSectionErrors: FunctionComponent<Props> = ({ errors }) => {
	if (errors === undefined || errors.length === 0) {
		return null;
	}

	return (
		<Hint theme="error" size="sm">
			<ul className="flex flex-col gap-1">
				{errors.map((error) => (
					<li key={error}>{error}</li>
				))}
			</ul>
		</Hint>
	);
};

export default EInvoiceSectionErrors;
